// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: _hlvShO_cZ-W
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import InvoiceItem from "../../InvoiceItem"; // plasmic-import: -fR3b8VmLe9a/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSubscriptionPaymentsPagePreviewCard.module.css"; // plasmic-import: _hlvShO_cZ-W/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: sgRe6pjmwXSr/icon
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon

createPlasmicElementProxy;

export const PlasmicSubscriptionPaymentsPagePreviewCard__VariantProps =
  new Array();

export const PlasmicSubscriptionPaymentsPagePreviewCard__ArgProps = new Array(
  "sendText",
  "merchantName",
  "amount",
  "subscriptionType",
  "subscriptionDate",
  "sidebarAmount",
  "subscriptionText"
);

const $$ = {};

function PlasmicSubscriptionPaymentsPagePreviewCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox___6CNy)}>
            <Icon4Icon
              data-plasmic-name={"goBackArrow"}
              data-plasmic-override={overrides.goBackArrow}
              className={classNames(projectcss.all, sty.goBackArrow)}
              role={"img"}
            />

            <div
              data-plasmic-name={"goBackText"}
              data-plasmic-override={overrides.goBackText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.goBackText
              )}
            >
              {"Go Back"}
            </div>
            <div
              data-plasmic-name={"sendButton"}
              data-plasmic-override={overrides.sendButton}
              className={classNames(projectcss.all, sty.sendButton)}
            >
              <div
                data-plasmic-name={"sendText"}
                data-plasmic-override={overrides.sendText}
                className={classNames(projectcss.all, sty.sendText)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Send",
                  value: args.sendText,
                  className: classNames(sty.slotTargetSendText)
                })}
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__moeUo)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Pulsebound",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__xs8Nj)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___2Cds5
                      )}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "$1,000.00 ",
                        value: args.amount,
                        className: classNames(sty.slotTargetAmount)
                      })}
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__dy0HT)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "monthly subscription",
                        value: args.subscriptionType,
                        className: classNames(sty.slotTargetSubscriptionType)
                      })}
                    </div>
                  </div>
                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__rq3ZZ)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Details >"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__rb0C6
                    )}
                  >
                    {"Confirm your payment method"}
                  </div>
                  <button
                    data-plasmic-name={"handleCardPayment"}
                    data-plasmic-override={overrides.handleCardPayment}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.handleCardPayment
                    )}
                    ref={ref => {
                      $refs["handleCardPayment"] = ref;
                    }}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___3Gnq
                      )}
                    >
                      {"Credit or debit card"}
                    </div>
                  </button>
                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__zL7Rp)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"subscriptionText"}
                    data-plasmic-override={overrides.subscriptionText}
                    className={classNames(projectcss.all, sty.subscriptionText)}
                  >
                    {renderPlasmicSlot({
                      defaultContents:
                        "By confirming, you allow Pulsebound to charge you in monthly cycles starting with September 1 to August 1.",
                      value: args.subscriptionText,
                      className: classNames(sty.slotTargetSubscriptionText)
                    })}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__btzqu
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__ksgxd)}>
                <div
                  data-plasmic-name={"closeButton"}
                  data-plasmic-override={overrides.closeButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.closeButton
                  )}
                >
                  {"X"}
                </div>
                <div
                  data-plasmic-name={"closeButton2"}
                  data-plasmic-override={overrides.closeButton2}
                  className={classNames(projectcss.all, sty.closeButton2)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "September 1 - August 1",
                    value: args.subscriptionDate,
                    className: classNames(sty.slotTargetSubscriptionDate)
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__hykq7)}>
                  {renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__ewoiH
                        )}
                      >
                        {"$300.00"}
                      </div>
                    ),

                    value: args.sidebarAmount,
                    className: classNames(sty.slotTargetSidebarAmount)
                  })}
                </div>
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceItemStack"}
                data-plasmic-override={overrides.invoiceItemStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceItemStack)}
              >
                <InvoiceItem
                  data-plasmic-name={"invoiceItem"}
                  data-plasmic-override={overrides.invoiceItem}
                  className={classNames("__wab_instance", sty.invoiceItem)}
                  item={"Social Media Management"}
                />
              </Stack__>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "goBackArrow",
    "goBackText",
    "sendButton",
    "sendText",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleCardPayment",
    "subscriptionText",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  goBackArrow: ["goBackArrow"],
  goBackText: ["goBackText"],
  sendButton: ["sendButton", "sendText"],
  sendText: ["sendText"],
  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleCardPayment",
    "subscriptionText",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "handleCardPayment",
    "subscriptionText"
  ],

  figmaPaste2: ["figmaPaste2", "handleCardPayment", "subscriptionText"],
  handleCardPayment: ["handleCardPayment"],
  subscriptionText: ["subscriptionText"],
  figmaPaste3: ["figmaPaste3"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  closeButton: ["closeButton"],
  closeButton2: ["closeButton2"],
  invoiceItemStack: ["invoiceItemStack", "invoiceItem"],
  invoiceItem: ["invoiceItem"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicSubscriptionPaymentsPagePreviewCard__ArgProps,
          internalVariantPropNames:
            PlasmicSubscriptionPaymentsPagePreviewCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSubscriptionPaymentsPagePreviewCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSubscriptionPaymentsPagePreviewCard";
  } else {
    func.displayName = `PlasmicSubscriptionPaymentsPagePreviewCard.${nodeName}`;
  }
  return func;
}

export const PlasmicSubscriptionPaymentsPagePreviewCard = Object.assign(
  // Top-level PlasmicSubscriptionPaymentsPagePreviewCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    goBackArrow: makeNodeComponent("goBackArrow"),
    goBackText: makeNodeComponent("goBackText"),
    sendButton: makeNodeComponent("sendButton"),
    sendText: makeNodeComponent("sendText"),
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    handleCardPayment: makeNodeComponent("handleCardPayment"),
    subscriptionText: makeNodeComponent("subscriptionText"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    closeButton2: makeNodeComponent("closeButton2"),
    invoiceItemStack: makeNodeComponent("invoiceItemStack"),
    invoiceItem: makeNodeComponent("invoiceItem"),
    // Metadata about props expected for PlasmicSubscriptionPaymentsPagePreviewCard
    internalVariantProps:
      PlasmicSubscriptionPaymentsPagePreviewCard__VariantProps,
    internalArgProps: PlasmicSubscriptionPaymentsPagePreviewCard__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicSubscriptionPaymentsPagePreviewCard;
/* prettier-ignore-end */
